class DashboardRequest {
    constructor({
                    body = '',
                    FileId = '',

                } = {}) {
        this.body = body;
        this.FileId = FileId;
    }    
}
export default DashboardRequest;